module.exports = __webpack_public_path__ + "media/images/lp-doughnut-top-left-edb7338c6d7bfa3cb3434a94582781bb.svg";